import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import mustang from "../../../../assets/info/mustang-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import eziFit from "../../../../assets/info/ford-mustang/ranger-fig-1_1_.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";

const FordMustang = () => {
  useSmallNav("Ford Mustang");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Ford Mustang"} bolder />
        <InfoHero image={mustang} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "If you have a New Model Ford Mustang, then you have come to the right place!"
              }
            />
            <InfoHeader
              size="smaller"
              text={
                "Pedders suspension have a full range of suspension products to suit your Mustang, and to suit your every need."
              }
            />
            <p>
              We offer 3 levels of suspension upgrade for your mustang,
              SportsRyder Lowering springs, SportsRyder Ezifit suspension kit,
              and our eXtreme XA coilover kits.
            </p>
            <InfoHeader size="smaller" text={"SportsRyder Lowering Springs"} />
            <p>
              Pedders SportsRyder Lowering Springs do exactly what they say.
              Lower your Mustang. Ideal for those seeking an improvement in
              looks, this kit consists of 4 Pedders SportsRyder lowering springs
              for your Mustang. These simply replace the original Ford springs.
              Pedders Coil springs are the foundations of the modern lowering
              suspension system. Their spring rate and 'loaded' or installed
              height are fundamental in influencing chassis dynamics, vehicle
              balance and ride quality. And of course, the loaded height
              determines the vehicle's ride height and its trim or attitude.
            </p>
            <p>
              Pedders SportsRyder coils are designed and engineered to the
              highest quality standards to deliver unrivalled performance,
              consistency and reliability.
            </p>
            <p>
              With Pedders SportsRyder Coil Springs the handling of most
              vehicles is substantially improved by increasing the original
              spring rate to a rate which reduces body roll and, in turn, aids
              tyre adhesion - without causing undue harshness or rigidity. Coil
              spring design and manufacture is a craft which requires strict
              adherence to a demanding series of procedures, all of which are
              critical to the performance of the final product.
            </p>
            <p>Key Features:</p>
            <ul>
              <li>30mm Lower than standard.</li>
              <li>Improved cornering and handling.</li>
              <li>its original Ford suspension.</li>
            </ul>
            <p>All backed by our 2 Year / 40,000klm warranty.</p>
            <hr />
            <InfoHeader smaller text={"SportsRyder Ezifit Suspension Kit"} />
            <p>
              This takes you to the next level. Utilising the same great
              SportsRyder lowering springs, we now add Pedders SportsRyder
              shocks. These are an upgraded unit, featuring revised damping
              rates for improved control to match Pedders SportsRyder coil
              springs. This kit is ideal for someone looking for improved looks
              and better handling, but without compromising on comfort. And to
              make it as Ezi as possible, this kit comes with fully assembled
              front struts making fitting as "Ezi" as it can be! Lowered look &
              great handling with a decent ride at a great price - all in a
              pre-assembled kit - too Ezi!
            </p>
            <p>Key Features:</p>
            <p>
              Pedders SportsRyder EziFit Suspension kit is the ideal alternative
              to buying separate components or coilovers when wanting to lower
              your Mustang.
            </p>
            <p>
              Reduced installation time and a decent ride/handling balance are
              the key benefits from the use of the Pedders EziFit Kit as the
              springs, struts and mounts are all supplied pre-assembled and
              ready to install. No need to use a spring compressor as the work
              is already done for you! Just unbolt the old and bolt in the new
              ITS PLUG & PLAY suspension at its best!
            </p>
            <ul>
              <li>
                Supplied as a MATCHED SET of pre-assembled suspension components
                including Pedders SportsRyder gas struts, Pedders SportsRyder
                lowered coil springs, bump stops, boot kits and strut mounts.
              </li>
              <li>
                Reduced installation time as the components are supplied
                pre-assembled and ready for direct fitment.
              </li>
              <li>
                Individually shock dyno-tested as a complete suspension system
                mated to your existing O.E. hardware for quality assurance ↦
                performance.
              </li>
              <li>
                The Pedders EziFit will lower your Mustang by approximately
                30mm.
              </li>
              <li>
                Pedders SportsRyder gas struts in the EziFit kit are made from
                heavy duty twin-tube gas construction technology & heavy duty
                reinforced double welded mountings for long term durability.
              </li>
              <li>
                The complete kit is a system designed and valved to work
                together. You will experience dynamic sports ride & handling
                that is suitable for daily driving as well as performance
                driving without a harsh ride.
              </li>
              <li>All backed by our 2 Year / 40,000klm warranty.</li>
            </ul>
            <hr />
            <InfoHeader smaller text={"SportsRyder eXtreme XA Coilover Kit"} />
            <p>
              For those looking for the ultimate in handling and suspension
              response, look no further than the Pedders SportsRyder eXtreme XA
              kit. Offering both adjustable damping and adjustable ride height,
              this kit has it all. At the forefront of sports suspension is
              SportsRyder eXtreme XA, height, bump and rebound adjustable
              coilovers and coilover sleeves, built to Pedders' stringent
              quality standards. They feature sports calibrated tunable damping,
              motorsport coil springs individually tuned to suit each
              application and a host of high-performance features including
              engineered mounting bracketry. The eXtreme XA coilover range is
              the pinnacle of performance suspension technology and the flagship
              of Pedders' SportsRyder range of specialist performance suspension
              products in Australia.
            </p>
            <p>Key Features:</p>
            <ul>
              <li>30 position adjustable bump and rebound damping.</li>
              <li>
                Fully adjustable high-grade steel lower mount for height
                adjustment.
              </li>
              <li>Fully threaded monotube body.</li>
              <li>High-Grade Aluminium Spring seats.</li>
              <li>Factory style bracketry for direct hassle free fitment.</li>
              <li>Alloy steel motorsport coil springs.</li>
              <li>Integrated dust boot to protect shaft and seal.</li>
              <li>Fully assembled top mounts.</li>
            </ul>
            <p>All backed by our 2 Year / 40,000klm warranty.</p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/6HVMPfSy4CE"
              title={"Ford Mustang Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/Sfows6Wyjk4"
              title={"Ford Mustang Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/iZ2J1dQ15Mg"
              title={"Ford Mustang Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Ford")
              .models.find((e) => e.display === "Mustang")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Pedders Sportsryder EziFit Assembly"}
              />
              <div>
                <StyledImgParts
                  src={eziFit}
                  alt="Pedders Sportsryder EziFit Assembly"
                />
              </div>
            </Gray>
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Ford" model="Mustang" /> */}
      </Container>
    </section>
  );
};

export default FordMustang;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
